module.exports = __webpack_public_path__ + "img/companies_mobile.ef34b658.png";